export default "__VITE_PUBLIC_ASSET__cad6586f__"